import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState,
  useRef,
} from 'react';

import {
BrowserRouter as Router,
Route,
Link,
Routes
} from "react-router-dom";

import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { Row, Col, Form, Button } from 'react-bootstrap'

//CFX LIVE
import CFX_Artifact from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import CFX_Address from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken-address.json';

//STACKCORE LIVE
import DualStackcoreNFTArtifact from '../live_artifacts/contracts/DualStackcoreNFT.sol/DualStackcoreNFT.json';
import DualStackcoreNFTAddress from '../live_artifacts/contracts/DualStackcoreNFT.sol/DualStackcoreNFT-address.json';

//CFALPHA LIVE
import CFALPHA_Artifact from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import CFALPHA_Address from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';

//CFOG LIVE
import OGNFTArtifact from '../live_artifacts/contracts/OGNFT.sol/OGNFT.json';
import OGNFTAddress from '../live_artifacts/contracts/OGNFT.sol/OGNFT-address.json';

const StyledDeployContractButton = styled.button`
  width: 240px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function DualStackcoreApp(): ReactElement {
  return (
    <StyledAppDiv>
      <NFTCreateContract />
    </StyledAppDiv>
  );
}

export function NFTCreateContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library, active, account } = context;

  const [signer, setSigner] = useState<Signer>();
  const [NFTContract, setNFTContract] = useState<Contract>();
  const [NFTContractAddr, setNFTContractAddr] = useState<string>('');

  const [image, setImage] = useState('');
  const [price, setPrice] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const reffirstRef = useRef(null);

  const [nftTokenName, setTokenName] = useState<string>('');
  const [nftTokenSymbol, setTokenSymbol] = useState<string>('');
  const [nftTokenOwner, setTokenOwner] = useState<string>('');
  const [approveAmountInput, setApproveAmountInput] = useState<string>('');
  const [buySTACKCOREButton, setBuyCFALPHAButton] = useState<string>('APPROVE BUSD & MINT $DUALSTACKCORE NFT');
  const [buySTACKCORECFXButton, setBuyCFALPHASafuuButton] = useState<string>('APPROVE CFX & MINT $DUALSTACKCORE NFT');

  const [totalBUSDRaised, setTotalBUSDRaised] = useState(0);
  const [totalCFXRaised, setTotalCFXRaised] = useState(0);
  const [busdBalance, setbusdBalance] = useState(0);
  const [safuuBalance, setsafuuBalance] = useState(0);
  const [totalNFTSupply, setTotalNFTSupply] = useState(0);
  const [totalFused, setTotalFused] = useState(0);
  const [totalMinted, setTotalMinted] = useState(0);

  const [nbrAlpha, setNbrAlpha] = useState<string>(''); // Alpha  NFT's
  const [nbrOG, setNbrOG] = useState<string>(''); // OG NFT's

  const [quantity, setQuantity] = useState('1');

  const [transferBUSDAmountInput, setTransferBUSDAmountInput] = useState<string>('');
  const [transferCFXAmountInput, setTransferCFXAmountInput] = useState<string>('');
  
  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }

    setSigner(library.getSigner());
  }, [library]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

     //test for account change
     useEffect(() => {
      handleAttachContract();
    }, [account]);

    //test for quantity change
    useEffect(() => {
      handleAttachContract();
    }, [quantity]);

  function handleAttachContract() {

    // only attach when a signer is defined
    if (!signer) {
      return;
    }


    async function attachNFTContract(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        DualStackcoreNFTArtifact.abi,
        DualStackcoreNFTArtifact.bytecode,
        signer
      );

      try {
        //NOTE: ALWAYS PRE-DEPLOYED
        //const p2eGameContract = await P2EGame.deploy('Cosmic Force','CFX');
        //await p2eGameContract.deployed();

        const nftContract = await NFT.attach(DualStackcoreNFTAddress.address);
       
        setNFTContract(nftContract);
 
       // window.alert(`P2EGame deployed to: ${p2eGameContract.address}`);

        const tokenName = await nftContract.name();
        const tokenSymbol = await nftContract.symbol();
        const tokenOwner = await nftContract.owner();
        const totalSupply = await nftContract.totalSupply();
        const totalFused = await nftContract.totalFused();

        setNFTContractAddr(nftContract.address);
        setTokenName(tokenName);
        setTokenSymbol(tokenSymbol);
        setTokenOwner(tokenOwner);
        setTotalNFTSupply(Number(totalSupply));
        setTotalFused(Number(totalFused));
        setTotalMinted(Number(totalSupply)-Number(totalFused));

        //Chech if BUSD approved and change to MINT buttin if so
        handleCheckApproveCFX();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachNFTContract(signer);
  }
  
  function handleCreateCFXNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function createNFT(signer: Signer, _quantity: String): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        DualStackcoreNFTArtifact.abi,
        DualStackcoreNFTArtifact.bytecode,
        signer
      );

      const CFX = new ethers.ContractFactory(
        CFX_Artifact.abi,
        CFX_Artifact.bytecode,
        signer
      );

      try {

        const CFX_Contract = await CFX.attach(CFX_Address.address);
      

        const amountApproved = await CFX_Contract.allowance(account, DualStackcoreNFTAddress.address);
        const balanceCFX = await CFX_Contract.balanceOf(account);

        const totalAllowanceRequired = Number(_quantity) * 100;

        //If not enough allowence left 100000000 = 1000 Safuu
        if (Number(amountApproved) <= (Number(ethers.utils.parseEther(totalAllowanceRequired.toString()))) ) {
          //Do Approve CFX

          const listingPrice = ethers.utils.parseEther("30000");

          const setTxn = await CFX_Contract.approve(DualStackcoreNFTAddress.address,listingPrice);

          await setTxn.wait();

          setBuyCFALPHASafuuButton('MINT $DUALSTACKCORE NFT WITH CFX');

          window.alert(`CFX Approve Success!`);

        }

        //************* = 250 with 18 )'s */
        var cost = 250000000000000000000;

        // Discount Implementation
        if (Number(nbrOG) > 0) {
          //Do 35% discount
          cost = (cost / 100) * 65;
        } else if (Number(nbrAlpha) > 0) {
            cost = (cost / 100) * 75;
        }
        
        if(Number(balanceCFX) < (cost * Number(_quantity))) {
          window.alert('Not enough CFX balance');
          return;
        }

        const nftContract = await NFT.attach(DualStackcoreNFTAddress.address);
       
        const ticker = "CFX";
        const tickerId = 1;
        const quantity = Number(_quantity);

        // mint nft 
        await(await nftContract.mint(tickerId, quantity, {
          gasLimit: Number(_quantity)*380000
      })).wait();
        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        const totalFused = await nftContract.totalFused();
        setTotalNFTSupply(Number(totalSupply));
        setTotalFused(Number(totalFused));
        setTotalMinted(Number(totalSupply)-Number(totalFused));


        setBuyCFALPHASafuuButton('MINT $DUALSTACKCORE NFT WITH CFX');
        handleCheckApproveCFX();

        if (Number(_quantity) == 1) {
          window.alert(`Created DUALSTACKCORE #${totalSupply} NFT`);
        } else {
          window.alert(`Created ${_quantity} DUALSTACKCORE NFTs Last ID: #${totalSupply} `);
        }

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer, quantity);
  }

  

  function handleCheckApproveCFX(): void {
   
      // only attach when a signer is defined
      if (!signer) {
        return;
      }
  
      async function approveCheckCFX(signer: Signer, _quantity: String): Promise<void> {
        
        //   const BUSDLIVE = new ethers.ContractFactory(
        //     BUSD_LIVEArtifact.abi,
        //     BUSD_LIVEArtifact.bytecode,
        //     signer
        //   );
    
          const CFX = new ethers.ContractFactory(
            CFX_Artifact.abi,
            CFX_Artifact.bytecode,
            signer
          );

          const ALPHA = new ethers.ContractFactory(
            CFALPHA_Artifact.abi,
            CFALPHA_Artifact.bytecode,
            signer
          );
    
          const OG = new ethers.ContractFactory(
            OGNFTArtifact.abi,
            OGNFTArtifact.bytecode,
            signer
          );
    
          try {

            const CFX_Contract = await CFX.attach(CFX_Address.address);
            const ALPHA_Contract = await ALPHA.attach(CFALPHA_Address.address);
            const OG_Contract = await OG.attach(OGNFTAddress.address);
              
            const amountApproved = await CFX_Contract.allowance(account,DualStackcoreNFTAddress.address);
    
            const contractBalanceCFX = await CFX_Contract.balanceOf(DualStackcoreNFTAddress.address);     
            const totalSafuuRaised = Number(ethers.utils.formatUnits(contractBalanceCFX,18));
            setTotalCFXRaised(Math.ceil(totalSafuuRaised));
            
      
            const walletNewBalanceCFX = await CFX_Contract.balanceOf(account);
            const newBalanceCFX = Number(ethers.utils.formatUnits(walletNewBalanceCFX,18));
            setsafuuBalance(newBalanceCFX);

            //************* = 250 with 18 )'s */
            var cost = 250000000000000000000;

            // Discount Implementation
            if (Number(nbrOG) > 0) {
              //Do 35% discount
              cost = (cost / 100) * 65;
            } else if (Number(nbrAlpha) > 0) {
                cost = (cost / 100) * 75;
            }
    
            //If not enough allowence left
            if (Number(amountApproved) >= (cost*Number(_quantity))) {
              setBuyCFALPHASafuuButton('MINT $DUALSTACKCORE NFT WITH CFX');
            } else {
              setBuyCFALPHASafuuButton('APPROVE CFX & MINT $DUALSTACKCORE NFT');
            }

            //Test if any ALPHA NFT's exist does not use ethes 18 digs
            const walletBalanceCFALPHA = await ALPHA_Contract.balanceOf(account);

            //Test if any ALPHA OG's exist does not use ethes 18 digs
            const walletBalanceOG = await OG_Contract.balanceOf(account);

            
            if (Number(walletBalanceCFALPHA)){
              setNbrAlpha('1'); //Just set to 1 don't need actual total
            } else {
              setNbrAlpha('');
            }

            if (Number(walletBalanceOG)){
              setNbrOG('1');
            } else {
              setNbrOG('');
            }
            
          } catch (error: any) {
            window.alert(
              'Error!' + (error && error.message ? `\n\n${error.message}` : '')
            );
          }
      }
    
    approveCheckCFX(signer, quantity);
  }

  function handleQuantityChange(_quantity: string): void {
    setQuantity(_quantity);

    //Chech if BUSD approved and change to MINT buttin if so
   // handleCheckApproveBUSD();
   // handleCheckApproveCFX();

  }
    
  return (
    <>
      
      <div className="container-fluid">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
            <Row className="g-4">
            <h6 className="p-4 text-center">
            Contract: {NFTContractAddr}
            </h6>
            </Row>
            <Row className="g-4">
            <h1 className="text-center">
            DUAL STACK CORE NFT
            </h1>
            </Row>
            <Row className="g-4">
            <Col>
            <h4 className="text-center">
              Fused
            </h4>
            </Col>
            <Col>
            <h4 className="text-center">
              Minted
            </h4>
            </Col>
            <Col>
            <h4 className="text-center">
              Max Supply (Minted)
            </h4>
            </Col>
          </Row>
          <Row className="g-4">
            <Col>
            <h5 className="text-center">
              {totalFused}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              {totalMinted}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              50
            </h5>
            </Col>
          </Row>
            <Row className="g-8">
            <Col>
            </Col>
            <Col className="text-center" style={{ minWidth: '450px' }}>
            <img  src='./images/CYAN_768_OPFULL.gif' className='img-fluid' alt='...' />
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <h5 className="p-4 text-center">
              250 $CFXv1 = 1 $DUALSTACKCORE NFT
            </h5>
          </Row>
          <Row className="g-4">
            {nbrOG ? (
            <>
            <h6 className="p-2 text-center">
              OG NFT DETECTED - 35% DISCOUNT WILL APPLY
            </h6>
            </>
            ) : (
            <>
             <h6 className="p-2 text-center">
              {nbrAlpha ? 'ALPHA NFT DETECTED - 25% DISCOUNT WILL APPLY' : 'NO ALPHA OR OG NFT DETECTED - NO DISCOUNT WILL APPLY'}
             </h6>
            </>
            )}
          </Row>
          <Row className="g-4">
          <Col>
          </Col>
          <Col>
          </Col>
            <Col>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">Select quantity to MINT</label>
            <select onChange={(e) => handleQuantityChange(e.target.value)} className="form-control" id="FormControlQuantity">
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
            </select>
          </div>
          <div>&nbsp;</div>
          </Col>
          <Col>
          </Col>
          <Col>
          </Col>
          </Row>
            <Row className="g-4">
            <Col>
            <div className="d-grid px-8">
              <Button onClick={handleCreateCFXNFT} variant="primary" size="lg">
                {buySTACKCORECFXButton}
              </Button>
            </div>
            </Col>
            <Col>
            <div className="d-grid px-8">
            <Link to="/dualstackfuse" target="_self">
              <Button variant="primary" size="lg">
                FUSE $DUALSTACKCORE NFT WITH 2 $STACKCOREs
              </Button>
            </Link>
            </div>
            </Col>
            </Row>
            <Row className="g-4">
            <h4 className="p-4 text-center">
            50 POWER UNITS 250 $CFX VALUE
            </h4>
            </Row>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            50 DUAL STACK CORE NFTs are on presale for $250 (250 $CFX). You can also use your ALPHA 25% or OG 35% discount. DUAL STACK COREs will give the extra boost required for heavy machinery, large starships, mining equipment and manufacturing. DUAL STACK COREs can boost and power multiple machinery items and equipment that are in a FIXED location.
            </h6>
            </Row>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            Single or multiple colour combinations can be used to FUSE 2 STACK COREs together making a DUAL STACK CORE NFT worth 250 $CFX gaining an extra 25% POWER BOOST and 25% EXTRA $CFX VALUE.
            </h6>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-6">
            <Col className=" text-center ">
            <img src='./images/DUAL_STACK_FUSINGPATH_V1_1200.jpg' className='img-fluid' alt='...' />
            </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/ocQMOPizHmg?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force intro video"  allowFullScreen></iframe>
              </div>
            </Row>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
